module.exports = __webpack_public_path__ + "static/best-est-roi-14d8d553b32f05be27c6e734255cc928.svg";